/**
 * Polyfill for Array.prototype.findLast in lib vue-advanced-cropper
 * for old browsers (Safari < 15.4)
 */
if (!Array.prototype.findLast) {
  Array.prototype.findLast = function <T>(
    this: T[],
    predicate: (value: T, index: number, array: T[]) => boolean,
  ): T | undefined {
    for (let i = this.length - 1; i >= 0; i--) {
      if (predicate(this[i], i, this)) {
        return this[i];
      }
    }
    return undefined;
  };
}
